<template>
	<v-container>
		<v-layout mb-3>
			<v-btn @click="openOfferView" class="no-print">
				Podgląd oferty
			</v-btn>
		</v-layout>
		<v-card-title class="mt-3 mb-3">
			<div>
				<h2 class="mb-3">Opinia końcowa</h2>
				<div class="evaluation-card evaluation-font-size">
					<div>
						<strong class="mr-3">Nazwa oferty:</strong> {{viewData.offerTitle}}
					</div>
					<div>
						<strong class="mr-3">Numer oferty:</strong> {{viewData.offerCode}}
					</div>
					<div class="mt-3" v-if="viewData.requestedDonations.length === 1">
						<strong class="mr-3">Wnioskowana kwota:</strong>
						{{formatMoney(viewData.requestedDonations[0])}} PLN
					</div>
					<div class="mt-3" v-else>
						<strong class="mr-3">Wnioskowane kwoty</strong>
						<div class="ml-2" v-for="(donation, index) in viewData.requestedDonations"
							v-bind:key="index">
							<strong class="mr-3">Moduł {{index + 1}}:</strong>
							{{formatMoney(donation)}} PLN
						</div>
					</div>
					<div class="mt-3">
						<strong class="mr-3">Kraj:</strong> {{viewData.country}}
					</div>
					<div v-if="viewData.extraCountries.length > 0">
						<strong class="mr-3">Kraje dodatkowe:</strong>
						{{viewData.extraCountries.join(", ")}}
					</div>
					<div v-if="viewData.author">
						<strong class="mr-3">Autor:</strong> {{viewData.author}}
					</div>
					<div v-if="viewData.sendDate">
						<strong class="mr-3">Data przesłania:</strong> {{viewData.sendDate}}
					</div>
				</div>
			</div>
		</v-card-title>

		<hr class="ma-4">
		<v-layout>
			<h3>Opinia końcowa</h3>
		</v-layout>
		<v-layout row wrap class="mt-4" v-if="!configuration.booleanEvaluation">
			<v-flex xs8>
				<v-layout row>
					<strong style="height: 50px">Końcowa opinia komisji:</strong>
					<div>
						<span style="color:blue; font-weight: bold" class="ml-2">{{getFinalPointsSum()}}</span>
					</div>
				</v-layout>
				<v-layout style="height: 24px">
					<v-flex xs9>
						W tym:
					</v-flex>
					<v-flex xs3/>
				</v-layout>
				<v-layout>
					<ul style="width: 100%">
						<li class="ma-1">
							<v-layout style="height: 24px">
								<v-flex xs9>
									<span>Średnia punktacja opiniujących:</span>
									<span style="color:blue; font-weight: bold" class="ml-2">{{getSubstantiveAverage()}}</span>
								</v-flex>
								<v-flex xs3>
									<v-checkbox v-model="viewData.includeSubstantiveAverageIntoFinalGrade"
										:disabled="true" style="margin: 0 0 0 24px;"/>
								</v-flex>
							</v-layout>
						</li>
						<li class="ma-1">
							<v-layout style="height: 24px">
								<v-flex xs9>
									<span>Punktacja komisji:</span>
									<span style="color:blue; font-weight: bold" class="ml-2">{{getCommitteePoints()}}</span>
								</v-flex>
								<v-flex xs3/>
							</v-layout>
						</li>
						<li class="ma-1">
							<v-layout style="height: 24px">
								<v-flex xs9>
									<span>Ocena dotychczasowej współpracy:</span>
									<span style="color:blue; font-weight: bold" class="ml-2">{{getCollaborationPoints()}}</span>
								</v-flex>
								<v-flex xs3>
									<v-checkbox v-model="viewData.includeCollaborationIntoFinalGrade"
										:disabled="true" style="margin: 0 0 0 24px;"/>
								</v-flex>
							</v-layout>
						</li>
					</ul>
				</v-layout>
			</v-flex>
		</v-layout>

		<hr class="ma-4">

		<vue-form-generator
			name="generator"
			ref="vfg"
			:model="evaluationData.model"
			:options="formGenerator.formOptions"
			:schema="formGenerator.currentSchema"
			v-if="viewData.showGenerator">
		</vue-form-generator>

		<hr class="ma-4">


		<h2 class="mb-4">Decyzja ministra w sprawie finansowania projektu</h2>

		<div v-if="viewData.reserved">
			<v-flex xs3 ml-5 mb-3>
				<v-checkbox
					aria-label="reserved"
					v-model="viewData.reserved"
					label="Rezerwa"
					:disabled="configuration.disabled">
				</v-checkbox>
			</v-flex>
		</div>

		<v-layout row wrap>
			<template v-for="(donation, index) in viewData.requestedDonations">
				<v-flex xs6 :key="donation+'-'+index">
					<h3 v-if="viewData.requestedDonations.length > 1" class="mb-3">Moduł {{index + 1}}</h3>
					<v-layout row>
						<v-flex xs4 mt-4>
							<strong>Przyznanie środków</strong>
						</v-flex>
						<v-flex xs6 ml-4>
							<v-select
								:data-vv-name="'minister-decision-'+index"
								data-vv-as="Decyzja ministra"
								:error-messages="vErrors.collect('minister-decision-'+index)"
								v-validate="'required'"
								aria-label="minister decision"
								style="height: 60px; font-size: 10pt;"
								:disabled="configuration.disabled"
								v-model="viewData.summaryDotations.find(el => el.moduleNumber === index + 1).ministerDecision"
								:items="['TAK', 'NIE']">
							</v-select>
						</v-flex>
					</v-layout>

					<v-expand-transition
						v-if="viewData.summaryDotations.find(el => el.moduleNumber === index + 1).ministerDecision === 'TAK'">
						<div>
							<v-layout row>
								<v-flex xs4 mt-4>
									<strong>Typ rekomendacji</strong>
								</v-flex>
								<v-flex xs6 ml-4>
									<v-select
										aria-label="recommendation type"
										style="height: 60px; font-size: 10pt;"
										:disabled="configuration.disabled"
										v-model="viewData.recommendingTypes[index]"
										:items="['W kwocie rekomendowanej', 'W kwocie zmienionej']"
										v-on:change="setDonationIfNecessary(index + 1)">
									</v-select>
								</v-flex>
							</v-layout>
							<v-layout row>
								<v-flex xs4 mt-4>
									<strong>Rekomendowana kwota</strong>
								</v-flex>
								<v-flex xs6 ml-4 mt-4>
									{{ formatMoney(viewData.summaryDotations.find(el => el.moduleNumber === index +
										1).dotation) }} PLN
								</v-flex>
							</v-layout>
							<div v-if="showJustificationField(index)">
								<v-layout row>
									<v-flex mt-4 mb-4>
										<strong>Uzasadnienie modyfikacji kwoty</strong>
									</v-flex>
								</v-layout>
								<v-layout row>
									<v-flex ml-3 mr-3>
										<div v-if="!configuration.disabled" class="no-print">
											<v-textarea
												browser-autocomplete="off"
												solo
												rounded
												auto-grow
												row-height="10"
												:data-vv-name="'donation-justification-'+index"
												data-vv-as="Uzasadnienie modyfikacji kwoty"
												:error-messages="vErrors.collect('donation-justification-'+index)"
												v-validate="'required|min:10'"
												placeholder="Uzasadnienie modyfikacji kwoty"
												background-color="grey lighten-3"
												v-model="viewData.summaryDotations.find(el => el.moduleNumber === index + 1).justification"
												aria-label="donation amount change justification">
											</v-textarea>
										</div>
										<div v-else class="no-print">
											{{viewData.summaryDotations.find(el =>
												el.moduleNumber === index + 1).justification}}
										</div>
										<div class="d-none print-only">
											{{viewData.summaryDotations.find(el =>
												el.moduleNumber === index + 1).justification}}
										</div>
									</v-flex>
								</v-layout>
							</div>
						</div>
					</v-expand-transition>
				</v-flex>
			</template>
		</v-layout>
	</v-container>
</template>

<script>
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Api} from "@/api";
	import {FinalEvaluation} from "@/api/generated/FinalEvaluation";
	import {PublicContestEvaluation} from "@/api/generated/PublicContestEvaluation";
	import {Numbers} from "@/utils/Numbers";

	export default {
		name: "FinalEvaluationView",

		data() {
			return {
				configuration: {
					form: "",
					disabled: true,
				},

				evaluationData: {
					model: undefined,
				},

				viewData: {
					showGenerator: false,
					offerId: "",
					offerTitle: "",
					offerCode: "",
					country: "",
					author: "",
					committeeId: "",
					committeeDecision: null,
					sendDate: "",
					requestedDonations: [],
					appliedDonations: [],
					firstCriterionName: "",
					secondCriterionName: "",
					extraCountries: [],
					conferenceDate: "",
					conferenceLeader: "",
					conferenceMembers: [],
					summaryDotations: [],
					sendEvaluationDialog: false,
					volunteers: [],
					recommendingTypes: [],
					reserved: false,
          includeSubstantiveAverageIntoFinalGrade: false,
          includeCollaborationIntoFinalGrade: false,
				},

				evaluation: {
					formal: [],
					substantive: [],
					agency: [],
					expert: [],
					committee: null,
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: [],
				},

			};
		},

		created() {
			this.loadData();
		},

		methods: {
			async loadData() {
				await Api.syncGet(this, "/final-evaluation/configuration?contestId=".concat(this.$route.params.id), successResponse => {
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.schema);
				});

				FinalEvaluation.get(this, this.$route.params.evaluationId, success => {
					this.viewData.offerTitle = success.title;
					this.viewData.offerId = success.offerId;
					this.configuration.booleanEvaluation = success.booleanEvaluation;
					this.viewData.offerCode = success.offerCode;
					this.viewData.author = success.nameSurname;
					this.viewData.committeeId = success.committeeId;
					this.viewData.country = success.country;
					this.viewData.volunteers = success.volunteers;
					this.viewData.committeeDecision = success.committeeDecision;
					this.viewData.extraCountries = [];
					this.viewData.reserved = success.reserved;
          this.viewData.includeSubstantiveAverageIntoFinalGrade = success.includeSubstantiveAverageIntoFinalGrade;
          this.viewData.includeCollaborationIntoFinalGrade = success.includeCollaborationIntoFinalGrade;
					this.viewData.firstCriterionName = success.firstCriterionName;
					this.viewData.secondCriterionName = success.secondCriterionName;
					success.extraCountries.forEach(country => {
						this.viewData.extraCountries.push(country);
					});
					while (this.viewData.requestedDonations.length) {
						this.viewData.requestedDonations.pop();
					}
					success.requestedDonations.forEach(donation => {
						this.viewData.requestedDonations.push(donation);
					});
					success.appliedDonations.forEach(donation => {
						this.viewData.appliedDonations.push(donation);
					});
					this.viewData.conferenceDate = success.conferenceDate;
					this.viewData.conferenceLeader = success.conferenceLeader;
					this.viewData.conferenceMembers = success.conferenceMembers;
					this.viewData.recommendingTypes = [];
					this.viewData.summaryDotations = success.summaryDotations;

					this.viewData.summaryDotations.forEach(item => {
						this.viewData.recommendingTypes.push(item.donationStatus === 'RECOMMENDED_VALUE' ?
							'W kwocie rekomendowanej' : item.donationStatus === 'CHANGED_VALUE' ?
								'W kwocie zmienionej' : '-');
						if (item.ministerDecision === "RECOMMENDED") item.ministerDecision = "TAK";
						else if (item.ministerDecision === "NOT_RECOMMENDED") item.ministerDecision = "NIE";
						else item.ministerDecision = undefined;
					});

					this.fillAppliedDonations(this.viewData.appliedDonations, this.viewData.summaryDotations);

					if (success.evaluationStatus === "FINISHED") {
						this.configuration.disabled = true;
					}
					if (success.filledForm === null) {
						this.evaluationData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.evaluationData.model = genericFormUtil.decodeSchema(success.filledForm);
					}
					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;

					this.getFinishedEvaluations(this.viewData.offerId);
					this.getCollaborationEvaluation(this.viewData.offerId);
					this.getOfferEvaluationPoints(this.viewData.offerId);
				});

			},

			applyGenericForm(form) {
				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.configuration.disabled);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.evaluationData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},
			getFinalPointsSum() {
        let finalPointsSum = parseFloat(this.getCommitteePoints());

        if (this.viewData.includeSubstantiveAverageIntoFinalGrade) {
          finalPointsSum += parseFloat(this.getSubstantiveAverage());
        }
        if (this.viewData.includeCollaborationIntoFinalGrade) {
          finalPointsSum += parseFloat(this.getCollaborationPoints());
        }

        return finalPointsSum.toFixed(2);
			},
			getCommitteePoints() {
				if (!this.evaluation.committee) return 0;
				return this.evaluation.committee.points.toFixed(2) || 0;
			},
			getSubstantiveAverage() {
				let count = this.evaluation.substantive.length;
				if (count === 0) return 0;
				if (count <= 2) {
					let evaluations = this.evaluation.substantive.map(item => parseFloat(item.evaluation));
					let sum = evaluations.reduce((a, b) => a + b, 0) || 0;
					return (sum / count).toFixed(2) || 0;
				} else {
					let evaluations = this.evaluation.substantive.map(item => parseFloat(item.evaluation));
					evaluations.sort((a, b) => a - b);
					let minDiff = evaluations[1] - evaluations[0];
					for (let i = 2; i < count; ++i) {
						minDiff = minDiff < evaluations[i] - evaluations[i - 1] ? minDiff : evaluations[i] - evaluations[i - 1];
					}

					for (let i = count - 1; i > 0; --i) {
						if (evaluations[i] - evaluations[i - 1] === minDiff) {
							return ((evaluations[i] + evaluations[i - 1]) / 2).toFixed(2);
						}
					}
				}
			},

			showJustificationField (index) {
				return this.viewData.recommendingTypes[index] === 'W kwocie zmienionej' ||
					parseFloat(this.viewData.summaryDotations.find(el => el.moduleNumber === index + 1).dotation).toFixed(2)
					!== parseFloat(this.viewData.requestedDonations[index]).toFixed(2);
			},

			getCollaborationPoints() {
				if (!this.evaluation.collaboration) return 0;
				return Math.round(this.evaluation.collaboration.evaluation * 2).toFixed(2) || 0;
			},

			getOfferEvaluationPoints(offerId) {
				PublicContestEvaluation.getOfferEvaluationPoints(this, offerId, successResponse => {
						this.evaluation.committee = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować oceny", errorResponse);
					});
			},

			getCollaborationEvaluation(offerId) {
				this.reinitializeEvaluationObject();
				PublicContestEvaluation.getFinishedCollaborationEvaluation(this, offerId, successResponse => {
						this.$set(this.evaluation, "collaboration", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych oceny współpracy", errorResponse);
					});
			},

			reinitializeEvaluationObject() {
				this.evaluation = {
					formal: [],
					substantive: [],
					agency: [],
					expert: [],
					committee: null,
				};
			},
			getFinishedEvaluations(offerId) {
				PublicContestEvaluation.getFinishedOfferEvaluations(this, offerId, successResponse => {
						successResponse.forEach(item => {
							this.evaluation[item.type.toLowerCase()].push(item);
						});
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych ocen", errorResponse);
					});
			},
			fillAppliedDonations(applied, summary) {
				for (let index = 0; index < summary.length; index++) {
					let summaryDotation = summary.find(el => el.moduleNumber === index + 1);
					if (summaryDotation !== undefined && summaryDotation.dotation === null) {
						summaryDotation.dotation = applied[index];
					}
				}
			},

      openOfferView() {
        this.$router.openInNewTab('/view/contest/' + this.$route.params.id + '/offer/' + this.viewData.offerId);
      },
		},
		mixins: [
			Numbers,
		],
	};
</script>

<style scoped>

</style>
